/* global Swiper */

export default {
  init() {
    // Partial Image Slider
    const partialImageSliders = $('.partial-image-slider');
    partialImageSliders.each(function() {
      const swiperContainer = $(this).find('.swiper-container').get(0);

      const slidesPerViewDesktop = $(swiperContainer).data('slides-per-view-desktop');
      const slidesPerViewTablet = $(swiperContainer).data('slides-per-view-tablet');
      const slidesPerViewMobile = $(swiperContainer).data('slides-per-view-mobile');

      const prevBtn = $(this).find('.swiper-navigation .prev').get(0);
      const nextBtn = $(this).find('.swiper-navigation .next').get(0);

      if (swiperContainer) {
        new Swiper(swiperContainer, {
          slidesPerView: slidesPerViewMobile ? slidesPerViewMobile : 1,
          spaceBetween: 16,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          breakpoints: {
            425: {
              slidesPerView: slidesPerViewTablet ? slidesPerViewTablet : 2,
            },
            768: {
              slidesPerView: slidesPerViewDesktop ? slidesPerViewDesktop : 3,
            },
          },
        });
      }
    });

    const commonOffersSection = $('section.common-offers-section');
    if (commonOffersSection.length) {
      const contentSwiperContainer = commonOffersSection.find('.content-container .swiper-container').get(0);
      const imageSwiperContainer = commonOffersSection.find('.image-container .swiper-container').get(0);
      const prevBtn = commonOffersSection.find('.swiper-navigation .prev').get(0);
      const nextBtn = commonOffersSection.find('.swiper-navigation .next').get(0);

      let imageSwiper, contentSwiper;

      if (imageSwiperContainer) {
        imageSwiper = new Swiper(imageSwiperContainer, {
          slidesPerView: 1,
          effect: 'fade',
          loop: true,
        });
      }

      if (contentSwiperContainer) {
        contentSwiper = new Swiper(contentSwiperContainer, {
          slidesPerView: 1,
          spaceBetween: 16,
          loop: true,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
        });
      }

      if (imageSwiper && contentSwiper) {
        imageSwiper.controller.control = contentSwiper;
        contentSwiper.controller.control = imageSwiper;
      }
    }

    // Occasions
    const commonOcassionsSection = $('section.common-occasions-section');
    if (commonOcassionsSection.length) {
      const swiperContainer = commonOcassionsSection.find('.swiper-container').get(0);
      const prevBtn = commonOcassionsSection.find('.swiper-navigation .prev').get(0);
      const nextBtn = commonOcassionsSection.find('.swiper-navigation .next').get(0);

      if (swiperContainer) {
        new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 16,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
        });
      }
    }

    const galleryBlock = $('.acf-block.gallery-block');
    if (galleryBlock.length) {
      const gallerySwiperContainer = galleryBlock.find('.gallery-swiper').get(0);
      const captionSwiperContainer = galleryBlock.find('.caption-swiper').get(0);
      const prevBtn = galleryBlock.find('.swiper-navigation .prev').get(0);
      const nextBtn = galleryBlock.find('.swiper-navigation .next').get(0);

      let gallerySwiper, captionSwiper;

      if (gallerySwiperContainer) {
        gallerySwiper = new Swiper(gallerySwiperContainer, {
          slidesPerView: 1,
          effect: 'fade',
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
        });
      }

      if (captionSwiperContainer) {
        captionSwiper = new Swiper(captionSwiperContainer, {
          slidesPerView: 1,
          effect: 'fade',
          controller: {
            control: gallerySwiper,
          },
        });
      }

      if (gallerySwiper && captionSwiper) {
        gallerySwiper.controller.control = captionSwiper;
      }
    }

    const bannerSlider = $('.banner-slider-wrapper');
    if (bannerSlider.length) {
      const swiperImageContainer = bannerSlider.find('.swiper-image-container').get(0);
      const swiperTitleContainer = bannerSlider.find('.swiper-text-container').get(0);
      const prevBtn = bannerSlider.find('.swiper-navigation .prev').get(0);
      const nextBtn = bannerSlider.find('.swiper-navigation .next').get(0);

      let imageSwiper, contentSwiper;

      if (swiperImageContainer) {
        imageSwiper = new Swiper(swiperImageContainer, {
          slidesPerView: 1,
          effect: 'fade',
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
        });
      }

      if (swiperTitleContainer) {
        contentSwiper = new Swiper(swiperTitleContainer, {
          slidesPerView: 1,
          spaceBetween: 16,
          controller: {
            control: imageSwiper, // Link contentSwiper to imageSwiper
          },
        });
      }

      if (imageSwiper && contentSwiper) {
        imageSwiper.controller.control = contentSwiper; // Link imageSwiper to contentSwiper
      }
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/components/sliders.js